import MainNavigation from './MainNavigation';
import MainToolbar from './MainToolbar';
import MainBreadcrumb from './MainBreadcrumb';
import MainFooter from './MainFooter';
import ProfileProviderCard from './ProfileProviderCard';
import FilteredConsentsList from './FilteredConsentsList';

export default {
    MainNavigation,
    MainToolbar,
    MainBreadcrumb,
    MainFooter,
    ProfileProviderCard,
    FilteredConsentsList,
};



// WEBPACK FOOTER //
// ./src/components/index.js